import React from 'react';
import { Belt } from './types';

interface TimelineTrackProps {
  belts: Belt[];
  beltSpacing: number;
}

export const TimelineTrack: React.FC<TimelineTrackProps> = ({ belts, beltSpacing }) => {
  const startX = 40; // Align with MacroBeltCircles start

  // 👇 Extend the arrow one full belt spacing beyond last belt
  const arrowPosition = startX + (belts.length * beltSpacing);
  const lineWidth = arrowPosition - startX; // Timeline line up to arrow base

  return (
    <>
      {/* Timeline line */}
      <div 
        className="absolute top-1/2 transform -translate-y-1/2 z-0" 
        style={{ 
          left: startX,
          width: lineWidth,
          height: '16px',
          backgroundColor: '#4b5563'
        }} 
      />

      {/* Timeline arrow */}
      <div 
        className="absolute top-1/2 transform -translate-y-1/2 z-10"
        style={{ left: arrowPosition }}
      >
        <div
          style={{
            width: 0,
            height: 0,
            borderTop: '18px solid transparent',
            borderBottom: '18px solid transparent',
            borderLeft: '36px solid #4b5563'
          }}
        />
      </div>
    </>
  );
};